<template>
  <div class="container">
    <Header :heading="this.headerHeading" :subHeading="this.headerSubHeading" />
    <div class="container">
      <div class="row mt-2 mb-5 justify-content-center">
        <div class="col-md-8">
          <ImageInput imgLabel="Upload Content Image" :inputType="true" />
        </div>
        <div class="col-md-8">
          <ImageInput imgLabel="Upload Style Image" :inputType="false" />
        </div>
      </div>
    </div>
    <div class="row g-3 my-3">
      <div class="col-sm">
        <Slider
          sliderTitle="Content Weight"
          sliderType="1"
          :minValue="0"
          :maxValue="1"
          :steps="0.01"
          :initialValue="0.4"
        />
      </div>
      <div class="col-md">
        <Slider
          sliderTitle="Style Weight"
          sliderType="2"
          :minValue="0"
          :maxValue="1"
          :steps="0.1"
          :initialValue="0.2"
        />
      </div>
    </div>
    <div class="d-inline-flex container justify-content-center">
      <Button buttonText="Process & Style" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ImageInput from "@/components/ImageInput.vue";
import Button from "@/components/Button.vue";
import Slider from "@/components/Slider.vue";

export default {
  name: "HomeView",
  components: {
    Header,
    ImageInput,
    Button,
    Slider,
  },
  data() {
    return {
      headerHeading: "NeuralStyle",
      headerSubHeading: "Style your snaps with the power of Deep Learning",
    };
  },
};
</script>
